import { render } from "./RawAccounts.vue?vue&type=template&id=22b5ba0a"
import script from "./RawAccounts.vue?vue&type=script&lang=js"
export * from "./RawAccounts.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/tio-patinhas/tio-patinhas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__